import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask500To599Service {

  constructor() { }
}
